import { RockyNotificationData } from '@modules/App/interfaces/UiNotification';
import { RootState } from '../store';

export const notificationsSelector = (state: RootState): RockyNotificationData[] => state.notifications.notifications;
